/**
 * @todo documenter cette fonction
 * @param the_hash
 * @returns {boolean}
 */
function fnGoScroll(the_hash) {
    let goscroll = false;
    let regex = new RegExp("\#(.*)","gi");
    let the_element = '';

    if(the_hash.match("\#(.+)")) {

        the_hash = the_hash.replace(regex,"$1");

        try {

            if($("#"+the_hash).length>0) {
                the_element = "#" + the_hash;
                goscroll = true;
            }
            else if($("a[name=" + the_hash + "]").length>0) {
                the_element = "a[name=" + the_hash + "]";
                goscroll = true;
            }

            if(goscroll) {
                $('html, body').animate({
                    scrollTop:$(the_element).offset().top-75
                }, 'slow');
                return false;
            }
        }catch(e)
        {
            //console.warn(e);
        }
    }
};

/**
 * @todo documenter cette fonction
 * @param element
 */
function fnScroll(element) {
    $(element).click(function(){
        let the_hash = $(this).attr("href");
        fnGoScroll(the_hash);
    });
};

if (location.hash) {
    window.scrollTo(0, 0);
    setTimeout(function() {
        window.scrollTo(0, 0);
        fnGoScroll(location.hash);
    }, 1);
}

fnScroll('a[href^="#"]');

// Injecte les fonction dans l'objet window pour y avoir accès dans les pages HTML
window.fnGoScroll = fnGoScroll;
window.fnScroll = fnScroll;
